import styled from 'styled-components';
export const ButtonsContainer = styled.div `
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: flex-start;
`;
export const buttonContainerStyle = {
    marginLeft: 16,
};
export const closeButtonContainerStyle = Object.assign(Object.assign({}, buttonContainerStyle), { width: 40, height: 40, paddingLeft: 0, paddingRight: 0, '@media (max-width: 1200px)': {
        width: 40,
        height: 40,
        paddingLeft: 0,
        paddingRight: 0,
    } });
//# sourceMappingURL=index.js.map